import { ActionTypes } from "redux/reducers/monthlyClosing/types";
import { api_get, PROYECT } from "services/api";
import {
  setSnackbar,
  startRequestComp,
  stopRequestComp,
} from "../search/searchActions";

const { SET_MONTHLY_CLOSINGS, SET_FILTERS } = ActionTypes;

export const getMonthlyClosings = (station, month, year) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/retentions/monthly-summary?idStation=${station?.id}&month=${month}&year=${year}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingMonthlyClosings"));
    try {
      const resp = await api_get(url);
      if (resp.length === 0) {
        dispatch(setSnackbar("No se encontraron cierres", "warning"));
      }
      dispatch({ type: SET_MONTHLY_CLOSINGS, payload: resp });
    } catch (error) {
      dispatch(setSnackbar(error, "danger"));
    } finally {
      dispatch(stopRequestComp("loadingMonthlyClosings"));
    }
  };
};

export const setMonthlyClosingFilters = (key = "", value) => ({
  type: SET_FILTERS,
  payload: { key, value },
});
